export const wechatApi = {
    signature: '/wechat/hubei/signature',
    getParamTicket: '/wechat/hubei/paramTicket',
    wechatShare: '/wechat/share/wanted'
}
